export const WAIT_LIST_MESSAGE = 'Account sign up is currently disabled.'
export const LOGIN_WAIT_LIST_MESSAGE = 'Unable to log in without account while account sign up is disabled.'
